import { Colors } from 'basic-ui-lib/constants';
import { IcLocation, IcPhone } from 'basic-ui-lib/icons';
import styled from 'styled-components';
import { Col, Row } from 'basic-ui-lib/components/Box';
import { Text } from 'basic-ui-lib/components/Text';
import { IStore } from 'modules/store/interfaces/api';

export interface StoreCardProps {
  store: IStore;
  selected?: boolean;
  onClick?: () => void;
}

const StoreCard = ({ store, selected = false, onClick }: StoreCardProps) => {
  return (
    <Container $selected={selected} onClick={onClick}>
      <Col gap={4}>
        <Text body_1 semibold color='primary.6' left>
          {store.storeName}
        </Text>
        <Row gap={8} alignItems='center'>
          <IconWrapper $selected={selected}>
            <IcPhone width={12} height={12} fill={selected ? Colors.primary[6] : Colors.neutral.text[3]} />
          </IconWrapper>
          <Text caption_2 color='neutral.text.6' left>
            {store.phone}
          </Text>
        </Row>
        <Row gap={8} alignItems='flex-start'>
          <IconWrapper $selected={selected} style={{ marginTop: 2 }}>
            <IcLocation width={12} height={12} fill={selected ? Colors.primary[6] : Colors.neutral.text[3]} />
          </IconWrapper>
          <Text caption_2 color='neutral.text.6' left className='address-text'>
            {store.address}
          </Text>
        </Row>
      </Col>
    </Container>
  );
};

export default StoreCard;

const Container = styled.div<{ $selected: boolean }>`
  padding: 16px;
  border-radius: 4px;
  border: 2px solid ${({ $selected }) => ($selected ? Colors.primary[6] : Colors.neutral.border[1])};
  background: ${({ $selected }) => ($selected ? Colors.primary[1] : Colors.neutral.bg[1])};
  cursor: pointer;
  transition: all 0.2s ease;

  &:hover {
    border-color: ${Colors.primary[6]};
  }

  .address-text {
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
    overflow: hidden;
    text-overflow: ellipsis;
  }
`;

const IconWrapper = styled.div<{ $selected: boolean }>`
  width: 24px;
  height: 24px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  background: ${({ $selected }) => ($selected ? Colors.primary[2] : Colors.neutral.bg[2])};
`;
